// extracted by mini-css-extract-plugin
export var dropOver = "_ji-2";
export var dropValid = "_ji-1";
export var hidden = "_ji-3";
export var line = "_ji-0";